import styled from 'styled-components'
import { pageContainerStyles } from '../../../themes/layout';

export const Page = styled.div`
  height: 100%;
  background-color: white;
  
  .headContainer {
    display: flex;
    flex-direction: row;
    
    .title {
      padding-left: 1rem;
    }
  }
  
  .navbar {
    position: relative !important;
  }
  
  .modal-center {
    display: flex;
    justify-content: center;
  }
  
  .hidden {
    display: none;
  }
`

export const Container = styled.div`
  ${pageContainerStyles}
  overflow: auto;
  position: relative;
  display: flex;
  flex-direction: column;
  background-color: var(--primary-contrast);
  height: 100%;
  
  .bodySignUp {
    width: 100%;
    max-width: 100%;
  }
  
    .contentBlock {
      width: 100%;
      max-width: 100%;
      
      .inputTextField {
        margin: 0.5rem 0;
      }

      .inputBox {
        display: flex;
        flex-direction: column;
      }

      .logoImg {
        width: 220px;
      }

      .inset {
        margin:20px 0 20px;
        font-size:13px;
      }

      .optional {
        white-space: pre;
      }
    }

    .password {
      margin-top: 10px
    }
  
  .itemInner {
    padding-bottom: 1rem;
  }
  
  .checkboxLabel {
    font-size: 1rem;
    font-style: normal;
    font-weight: 400;
    line-height: 150%;
    letter-spacing: 0.15px;
    font-family: var(--fontMain);
  }
  
  .itemContent {
    padding-bottom: 1rem;
  }
  
  .toLogIn {
    display: flex;
    justify-content: center;
    padding: var(--2, 1rem) 0 0;
    font-size: var(--typography-body-1-bold-size);
    text-align:center;
    white-space: pre;
  }
  
  .helpLinks {
    display: flex;
    flex-direction: row;
    justify-content: center;
    font-size: var(--typography-body-1-bold-size);
    padding: 2.5rem 0 0;
  }
  
  .item-input {
    font-size: 1rem;
  }
  
  .labeledCheckbox {
    padding: 0.5rem 0;
  }
  
  .subtitle {
    font-style: normal;
    font-weight: 500;
    font-size: 18px;
    line-height: 22px;
    text-align: center;
    padding: 1rem;
  }
  .favFilter {
    font-style: normal;
    font-weight: 600;
    font-size: 0.875rem;
    
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    
    padding: 1rem;
    
    .underlined {
      border-bottom: 3px solid #0139A0;
      height: fit-content;
    }
  }
`

